import {Button} from '#component/base';
import {sprinkles} from '#style/sprinkles';

import {QuestionControlsProps} from './QuestionControls.types';

export const QuestionControls = ({
  disabledNext,
  hiddenBack = false,
  onBack,
  onNext,
  nextLabel,
}: QuestionControlsProps) => {
  return (
    <div
      className={sprinkles({
        content: 'between',
        dir: ['col', 'row'],
        flex: 'flex',
        gap: [8, 20],
      })}>
      {!hiddenBack && (
        <Button disabled={!onBack} onClick={onBack} variant="secondary">
          Back
        </Button>
      )}
      <Button
        disabled={disabledNext}
        onClick={onNext ? onNext : undefined}
        type={onNext ? undefined : 'submit'}>
        {nextLabel || 'Next'}
      </Button>
    </div>
  );
};
